import React from "react";

import { observer } from "mobx-react";

import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

import { SportItem } from ".";

export const SportsList = observer(function SportsList(props: {
	store: {
		menu: PrematchOfferMenuStore["menu"];
		selectedSport: PrematchOfferMenuStore["selectedSport"];
		toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
	} & Parameters<typeof SportItem>[0]["store"];
}) {
	return (
		<>
			<ErrorBoundaryWithPropagation
				componentName={"Desktop/SportItems.tsx"}
			>
				{props.store.menu.children.map((sport) => (
					<SportItem
						key={sport.node.id}
						item={sport}
						store={props.store}
					/>
				))}
			</ErrorBoundaryWithPropagation>
		</>
	);
});
